<mat-list *ngIf="selectedValues && selectedValues.length && !asInfo">
    <mat-list-item><strong>Selected values:</strong></mat-list-item>
    <mat-list-item class="margin-left-sm" *ngFor="let element of selectedValues">
        {{getTextValue(element)}}
    </mat-list-item>
</mat-list>
<div *ngIf="selectedValues && selectedValues.length && asInfo" class="values-as-tooltip">
    <mat-icon [matTooltip]="getAllText(selectedValues)">info_outline</mat-icon>
</div>
